<form class="form-container" [formGroup]="form">
    @if (f['groupId'].value != null) {
        <h2 mat-dialog-title>{{'UPDATE_GROUP' | translate}}</h2>
    } @else {
        <h2 mat-dialog-title>{{'ADD_GROUP' | translate}}</h2>
    }
    <mat-dialog-content class="mat-typography">
        <mat-form-field appearance="outline">
            <mat-label>{{'GROUP_NAME' | translate}} </mat-label>
            <input matInput formControlName="name">
            @if (f['name'].errors) {
            <mat-error>
                @if (f['name'].errors['required']) { <span>{{'GROUP_NAME_REQUIRED' | translate}}</span>}
                @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
            <input matInput formControlName="description">
            @if (f['description'].errors) {
            <mat-error>
                @if (f['description'].errors['required']) { <span>{{'DESCRIPTION_REQUIRED' | translate}}</span>}
                @if (f['description'].errors['maxlength']) { <span>{{'MAX_LENGTH_300' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'GROUP_TYPE' | translate}}</mat-label>
            <mat-select formControlName="groupType">
                @for (option of groupTypeOptions; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                }
            </mat-select>
            @if (f['groupType'].errors) {
            <mat-error>
                @if (f['groupType'].errors['required']) { <span>{{'GROUP_TYPE_REQUIRED' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (f['groupId'].value != null) {
        <button mat-button class="btn-primary" color="primary" [disabled]="form.invalid" (click)="edit()" color="primary" cdkFocusInitial>{{'Save' |
            translate}} </button>
        } @else {
        <button mat-button class="btn-primary" color="primary" [disabled]="form.invalid" (click)="add()" color="primary" cdkFocusInitial>{{'Add_BUTTON'
            | translate}} </button>
        }
        <button mat-button class="btn-secondary" mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>